import React from 'react';
import TextAreaField from '../../../Forms/Input/TextAreaField';
import { usePurchaseInvalidation } from '../../../../hooks/purchases/invalidation/usePurchaseInvalidation';

type Props = {
  onSubmit: () => void; // acción al presionar el botón
};

const PurchaseCancelReasonSection: React.FC<Props> = ({ onSubmit }) => {
  const { form, formErrors, updateField, isSubmitting } = usePurchaseInvalidation();

  return (
    <div className="space-y-6">
      {/* Campo para escribir el motivo */}
      <TextAreaField
        label="Motivo de Anulación"
        name="comment"
        placeholder="Ejemplo: Error en los datos del proveedor o en los montos de la compra."
        value={form.comment ?? ''}
        onChange={(e) => updateField('comment', e.target.value)}
        iconKey="edit"
        rows={4}
        required
        error={formErrors.comment}
      />

      {/* Botón de envío */}
      <div className="flex justify-end">
        <button
          type="button"
          onClick={onSubmit}
          disabled={isSubmitting}
          className="inline-flex rounded bg-[#DC3545] px-4 py-2 font-semibold text-white hover:bg-opacity-90 disabled:opacity-50"
        >
          {isSubmitting ? 'Anulando...' : 'Anular Compra'}
        </button>
      </div>
    </div>
  );
};

export default PurchaseCancelReasonSection;
